import { render, staticRenderFns } from "./NormalSearchNav273.vue?vue&type=template&id=48135ffa&scoped=true"
import script from "./NormalSearchNav273.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav273.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48135ffa",
  null
  
)

export default component.exports